if (!customElements.get('mox-holiday-notice')) {
  customElements.define('mox-holiday-notice', class extends HTMLElement {
    connectedCallback() {
      this.update = () => {
        clearTimeout(this.timer);
        const end = Date.parse(this.dataset.end);
        this.hidden = !Number.isFinite(end) || Date.now() >= end;
        if (!this.hidden) this.timer = setTimeout(this.update, Math.max(1, Math.min(end - Date.now(), 60000)));
      };
      this.update();
      window.addEventListener('pageshow', this.update);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      window.removeEventListener('pageshow', this.update);
    }
  });
}
